import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Preload modules to prevent loading chunk failed error when offline
import '@ionic/core/dist/esm/ion-alert.entry.js';
import '@ionic/core/dist/esm/ion-loading.entry.js';
import '@ionic/core/dist/esm/ion-modal.entry.js';
import '@ionic/core/dist/esm/ion-toast.entry.js';
import '@ionic/core/dist/esm/ion-action-sheet.entry.js';
import '@ionic/core/dist/esm/ion-popover.entry.js';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
